import React from "react";

function ValidIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="700pt"
      height="700pt"
      viewBox="0 0 700 700"
      className={className}
    >
      <defs>
        <symbol id="v" overflow="visible">
          <path d="M.281-.016A.134.134 0 01.22 0H.172a.172.172 0 01-.11-.031.148.148 0 01-.046-.11c0-.05.015-.093.046-.125s.067-.047.11-.047c.02 0 .035.008.047.016.02 0 .039.008.062.016v.062C.258-.227.242-.234.234-.234A.084.084 0 00.187-.25c-.03 0-.054.012-.062.031-.012.012-.016.04-.016.078 0 .024.004.043.016.063.008.023.031.031.063.031h.046a.188.188 0 01.047-.031z"></path>
        </symbol>
        <symbol id="c" overflow="visible">
          <path d="M.203-.156C.191-.164.18-.172.172-.172c-.024 0-.04.008-.047.016C.113-.145.109-.13.109-.11V0H.031v-.219H.11v.032C.117-.207.13-.22.141-.22c.007-.008.02-.015.03-.015h.032z"></path>
        </symbol>
        <symbol id="a" overflow="visible">
          <path d="M.25-.11v.016H.094c0 .024.004.04.015.047h.079c.019-.008.039-.02.062-.031v.062A.134.134 0 01.187 0H.142C.098 0 .066-.008.047-.031.023-.051.016-.078.016-.11c0-.04.007-.07.03-.094.02-.02.052-.031.095-.031.03 0 .054.011.078.03.02.024.031.056.031.095zM.187-.14a.017.017 0 00-.015-.016C.16-.164.148-.172.14-.172c-.012 0-.024.008-.032.016-.011 0-.015.008-.015.015z"></path>
        </symbol>
        <symbol id="j" overflow="visible">
          <path d="M.14-.11c-.023 0-.038.008-.046.016v.047h.031c.008 0 .02-.004.031-.016.008-.007.016-.019.016-.03V-.11zm.11-.015V0H.172v-.031L.14 0H.094A.115.115 0 01.03-.016C.02-.023.016-.046.016-.078c0-.02.007-.035.03-.047a.213.213 0 01.079-.016h.047c0-.02-.008-.03-.016-.03H.031V-.22h.047c.02-.008.035-.015.047-.015.04 0 .07.011.094.03.02.024.031.048.031.079z"></path>
        </symbol>
        <symbol id="b" overflow="visible">
          <path d="M.11-.281v.062h.078v.047H.109v.125h.062V0H.126a.155.155 0 01-.078-.016C.035-.023.03-.046.03-.078v-.094H0v-.047h.031V-.28z"></path>
        </symbol>
        <symbol id="i" overflow="visible">
          <path d="M.188-.188v-.124H.25V0H.187v-.031L.158 0H.108C.086 0 .066-.008.047-.031.023-.051.016-.078.016-.11c0-.04.007-.07.03-.094.02-.02.04-.031.063-.031.02 0 .036.007.047.015.008 0 .02.012.032.032zM.14-.047c.007 0 .02-.004.03-.016C.18-.07.188-.086.188-.109a.084.084 0 00-.015-.047C.16-.164.148-.172.14-.172c-.024 0-.04.008-.047.016v.093c.008.012.023.016.047.016z"></path>
        </symbol>
        <symbol id="h" overflow="visible">
          <path d="M.156-.047c.008 0 .02-.004.032-.015C.195-.07.203-.086.203-.11a.084.084 0 00-.016-.047C.176-.164.165-.172.158-.172c-.024 0-.04.008-.048.016v.093c.008.012.024.016.047.016zM.11-.187C.117-.207.13-.22.141-.22c.007-.008.02-.015.03-.015.032 0 .056.011.079.03.02.024.031.056.031.095a.11.11 0 01-.031.078A.1.1 0 01.172 0H.14a.119.119 0 01-.032-.031V0H.031v-.312H.11z"></path>
        </symbol>
        <symbol id="g" overflow="visible">
          <path d="M0-.219h.078l.063.14.047-.14h.078L.172.016a.115.115 0 01-.047.062.084.084 0 01-.047.016H.031V.03h.047C.086.031.098.023.11.016V0z"></path>
        </symbol>
        <symbol id="e" overflow="visible">
          <path d="M.031-.297H.11V0H.031z"></path>
        </symbol>
        <symbol id="u" overflow="visible">
          <path d="M0-.297h.078l.063.11.078-.11h.078l-.11.172V0H.11v-.125z"></path>
        </symbol>
        <symbol id="t" overflow="visible">
          <path d="M.031-.297H.11v.11l.11-.11h.094l-.141.14L.328 0H.234L.11-.11V0H.031z"></path>
        </symbol>
        <symbol id="s" overflow="visible">
          <path d="M.172-.25a.047.047 0 00-.047.031c-.012.012-.016.04-.016.078 0 .024.004.043.016.063.008.023.023.031.047.031.031 0 .05-.008.062-.031a.164.164 0 000-.14C.223-.239.204-.25.172-.25zm0-.063c.05 0 .086.016.11.047a.171.171 0 01.046.125.148.148 0 01-.047.11C.258-.008.223 0 .171 0a.172.172 0 01-.109-.031.148.148 0 01-.046-.11c0-.05.015-.093.046-.125s.067-.046.11-.046z"></path>
        </symbol>
        <symbol id="f" overflow="visible">
          <path d="M.031-.297h.094l.11.203v-.203h.078V0H.219l-.11-.203V0H.031z"></path>
        </symbol>
        <symbol id="r" overflow="visible">
          <path d="M.172-.313v.047H.14c-.012 0-.024.008-.032.016v.031h.063v.047H.109V0H.047v-.172H0v-.047h.047v-.015c0-.032.004-.051.016-.063.007-.008.03-.016.062-.016z"></path>
        </symbol>
        <symbol id="d" overflow="visible">
          <path d="M.14-.172c-.023 0-.038.008-.046.016v.093c.008.012.023.016.047.016.02 0 .03-.004.03-.016C.18-.07.188-.086.188-.109a.084.084 0 00-.015-.047C.172-.164.16-.172.14-.172zm0-.062c.04 0 .07.011.094.03.02.024.032.056.032.095a.11.11 0 01-.032.078C.211-.008.18 0 .141 0 .098 0 .066-.008.047-.031.023-.051.016-.078.016-.11c0-.04.007-.07.03-.094.02-.02.052-.031.095-.031z"></path>
        </symbol>
        <symbol id="q" overflow="visible">
          <path d="M.25-.188c0-.007.004-.019.016-.03.02-.009.035-.016.046-.016.032 0 .051.011.063.03.008.024.016.044.016.063V0H.328v-.125c0-.02-.008-.031-.016-.031a.017.017 0 00-.015-.016c-.012 0-.024.008-.031.016C.254-.145.25-.13.25-.11V0H.172v-.156C.172-.164.16-.172.14-.172c-.012 0-.024.008-.032.016V0H.031v-.219H.11v.031c.008-.019.02-.03.032-.03.007-.009.02-.016.03-.016.02 0 .036.007.048.015.008.012.02.024.031.031z"></path>
        </symbol>
        <symbol id="p" overflow="visible">
          <path d="M.266-.14V0H.187v-.14a.017.017 0 00-.015-.016v-.016H.156c-.011 0-.023.008-.031.016C.113-.145.109-.13.109-.11V0H.031v-.313H.11v.126C.117-.207.13-.22.141-.22c.007-.008.02-.015.03-.015.032 0 .052.011.063.03.02.024.032.044.032.063z"></path>
        </symbol>
        <symbol id="o" overflow="visible">
          <path d="M.031-.094v-.125H.11V-.047h.032c.007 0 .02-.004.03-.015C.18-.07.188-.086.188-.11v-.11H.25V0H.187v-.031L.158 0H.108a.115.115 0 01-.062-.016.155.155 0 01-.016-.078z"></path>
        </symbol>
        <symbol id="n" overflow="visible">
          <path d="M.266-.14V0H.187v-.14a.017.017 0 00-.015-.016v-.016H.156c-.011 0-.023.008-.031.016C.113-.145.109-.13.109-.11V0H.031v-.219H.11v.032C.117-.207.13-.22.141-.22c.007-.008.02-.015.03-.015.032 0 .052.011.063.03.02.024.032.044.032.063z"></path>
        </symbol>
        <symbol id="m" overflow="visible">
          <path d="M.031-.297h.14c.032 0 .056.012.079.031.02.012.031.032.031.063S.27-.145.25-.125a.165.165 0 01-.078.016H.109V0H.031zM.11-.25v.094h.079C.195-.164.203-.18.203-.203c0-.008-.008-.02-.016-.031C.176-.242.165-.25.158-.25z"></path>
        </symbol>
        <symbol id="l" overflow="visible">
          <path d="M.031-.219H.11V0C.11.02.098.04.08.063.065.082.046.092.015.092h-.032V.032h.032C.023.031.03.02.03 0zm0-.093H.11v.062H.031z"></path>
        </symbol>
        <symbol id="k" overflow="visible">
          <path d="M.219-.219v.063C.207-.164.195-.172.187-.172h-.03c-.024 0-.04.008-.048.016C.098-.145.094-.13.094-.11c0 .023.004.039.015.046.008.012.024.016.047.016h.032c.007-.008.019-.015.03-.015V0H.142C.098 0 .066-.008.047-.031.023-.051.016-.078.016-.11c0-.04.007-.07.03-.094.02-.02.052-.031.095-.031.02 0 .035.007.047.015h.03z"></path>
        </symbol>
      </defs>
      <path
        fillRule="evenodd"
        d="M286.39 329.75l-66.359-66.359c-21.738-21.738-39.867-26.742-53.07-22.559-5.332 1.64-10.008 4.84-13.863 8.941-4.02 4.266-7.137 9.598-9.352 15.422-6.07 15.914-5.003 35.027 5.66 45.688l98.517 98.516c18.867 18.867 31.664 28.383 43.39 28.383 11.813 0 24.528-9.433 43.392-28.3l215.89-215.89c10.664-10.665 11.73-29.696 5.66-45.689-2.215-5.824-5.414-11.156-9.352-15.422-3.855-4.101-8.531-7.218-13.863-8.941-13.289-4.184-31.336.82-53.07 22.559l-188.58 188.58-4.922-4.922z"
      ></path>
      <use x="70" y="561.23" xlinkHref="#v"></use>
      <use x="70.301" y="561.23" xlinkHref="#c"></use>
      <use x="70.504" y="561.23" xlinkHref="#a"></use>
      <use x="70.781" y="561.23" xlinkHref="#j"></use>
      <use x="71.059" y="561.23" xlinkHref="#b"></use>
      <use x="71.254" y="561.23" xlinkHref="#a"></use>
      <use x="71.531" y="561.23" xlinkHref="#i"></use>
      <use x="71.969" y="561.23" xlinkHref="#h"></use>
      <use x="72.262" y="561.23" xlinkHref="#g"></use>
      <use x="72.672" y="561.23" xlinkHref="#e"></use>
      <use x="72.824" y="561.23" xlinkHref="#u"></use>
      <use x="73.121" y="561.23" xlinkHref="#e"></use>
      <use x="73.273" y="561.23" xlinkHref="#t"></use>
      <use x="73.594" y="561.23" xlinkHref="#s"></use>
      <use x="73.941" y="561.23" xlinkHref="#f"></use>
      <use x="70" y="561.641" xlinkHref="#r"></use>
      <use x="70.18" y="561.641" xlinkHref="#c"></use>
      <use x="70.379" y="561.641" xlinkHref="#d"></use>
      <use x="70.664" y="561.641" xlinkHref="#q"></use>
      <use x="71.234" y="561.641" xlinkHref="#b"></use>
      <use x="71.43" y="561.641" xlinkHref="#p"></use>
      <use x="71.719" y="561.641" xlinkHref="#a"></use>
      <use x="72.141" y="561.641" xlinkHref="#f"></use>
      <use x="72.484" y="561.641" xlinkHref="#d"></use>
      <use x="72.766" y="561.641" xlinkHref="#o"></use>
      <use x="73.059" y="561.641" xlinkHref="#n"></use>
      <use x="73.492" y="561.641" xlinkHref="#m"></use>
      <use x="73.793" y="561.641" xlinkHref="#c"></use>
      <use x="73.996" y="561.641" xlinkHref="#d"></use>
      <use x="74.277" y="561.641" xlinkHref="#l"></use>
      <use x="74.418" y="561.641" xlinkHref="#a"></use>
      <use x="74.695" y="561.641" xlinkHref="#k"></use>
      <use x="74.941" y="561.641" xlinkHref="#b"></use>
    </svg>
  );
}

export default ValidIcon;